<template>
    <div class="fluid fill-height fill-width" style="width: 100%;flex: 1 1 auto;position: relative;">
        <div id="MyViewerDiv" style="right: 0px;height: 100%;" v-bind:style="{right: (fullWidth) ? '0' : '500px'}"></div>
    </div>
</template>

<script>
    import ExternalLoader from '@/lib/external-loader'
    import FilesRepository from '@/repositories/FilesRepository';

    export default {
        name: 'LargeModelViewer',
        mounted() {
            // load Resources
            let loader = new ExternalLoader(document);
            let resources = ["https://developer.api.autodesk.com/modelderivative/v2/viewers/6.5.1/viewer3D.min.js", "/vendor/lmv/style.min.css"];
            loader.load(resources).then(() => { this.loaded = true });
            this.$root.$emit('show-register-ad');
        },
        props: {
            fullWidth: Boolean,
            hash: String,
            token: String,
        },
        watch: {
            loaded: function () {
                this.load();
            },
            hash: function () {
                this.load();
            }
        },
        data () {
            return {
                loaded: true,
            }
        },
        methods: {

            load() {
                if (this.hash && this.loaded) {
                    FilesRepository.getLmvTokens(this.hash, this.token)
                        .then((response)=>{
                            if (response.data) {
                                this.initViewer(response.data.accessToken, response.data.documentId);
                            }
                        })
                        .catch((error)=>{
                            this.error(error);
                        })
                }
            },

            initViewer(accessToken, docId) {
                var options = {
                    env: 'AutodeskProduction',
                    accessToken: accessToken
                };
                var documentId = "urn:" + docId;
                Autodesk.Viewing.Initializer(options, () => {
                    Autodesk.Viewing.Document.load(documentId, this.onDocumentLoadSuccess, this.onDocumentLoadFailure);
                });
            },

            onDocumentLoadSuccess(doc) {

                // A document contains references to 3D and 2D viewables.
                var viewables = Autodesk.Viewing.Document.getSubItemsWithProperties(doc.getRootItem(), {'type':'geometry'}, true);
                if (viewables.length === 0) {
                    console.error('Document contains no viewables.');
                    return;
                }

                // Choose any of the avialble viewables
                var initialViewable = viewables[0];
                var svfUrl = doc.getViewablePath(initialViewable);
                var modelOptions = {
                    sharedPropertyDbPath: doc.getPropertyDbPath()
                };

                var viewerDiv = document.getElementById('MyViewerDiv');
                var viewer = new Autodesk.Viewing.Private.GuiViewer3D(viewerDiv);
                viewer.start(svfUrl, modelOptions, this.onLoadModelSuccess, this.onLoadModelError);
            },

            onLoadModelSuccess(model) {
                this.$emit('loaded');
            },

            onDocumentLoadFailure(viewerErrorCode) {
                console.error('onDocumentLoadFailure() - errorCode:' + viewerErrorCode);
            },

            onLoadModelError(viewerErrorCode) {
                console.error('onLoadModelError() - errorCode:' + viewerErrorCode);
            },

            finished() {
                this.$emit('loaded');
            },

            error(error) {
                this.$emit('error', error);
            },
        }
    };
</script>


<style scoped>
    #MyViewerDiv {
        left: 0;
        top: 0;
        bottom: 0;
        position: absolute;
    }
</style>